/* eslint-disable react/no-danger */
import React from "react"
import propTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"

import SEO from "../components/Seo"
import converter from "../converter"
import withTranslation from "../i18n/withTranslation"
import CollectionItem from "../components/CollectionItem"

const Wrapper = styled.div`
  .react-parallax-background-children {
    width: 100%;
  }

  .bg {
    height: 50vh;
    width: 100%;

    img {
      width: 100%;
    }
  }
`
const Desc = styled.div`
  max-width: 860px;
  padding: 60px 20px;
  margin: 0 auto;
  text-align: center;
  font-weight: lighter;
  color: #080808;

  p {
    line-height: 1.5em;
  }
`

const Cover = styled.div`
  width: 100%;
  height: 50vh;
  background-image: ${props => `url(${props.coverImg})`};
  background-size: cover;
  background-position: center center;
`

const createMarkup = content => {
  return { __html: content }
}

const CollectionTemplate = ({ data, t, i18n }) => {
  const {
    main: {
      frontmatter: { cover, bodyES },
      html: content,
    },
    items: { edges: collectionItems },
  } = data

  const { language } = i18n
  const aboutText = language === "es_MX" ? bodyES : content

  return (
    <Wrapper>
      <SEO title="Collections" />

      <Cover coverImg={cover} />

      <Desc>
        <h3>{t("collection.about")}</h3>
        <div dangerouslySetInnerHTML={createMarkup(aboutText)} />
      </Desc>

      {collectionItems.map(item => (
        <CollectionItem
          title={item.node.frontmatter.collection}
          name={item.node.frontmatter.name}
          description={
            language === "es_MX"
              ? converter.makeHtml(item.node.frontmatter.bodyES)
              : item.node.html
          }
          thumbImg={item.node.frontmatter.thumb}
          featuredImg={item.node.frontmatter.featured}
          zoomImg={item.node.frontmatter.zoomimg}
        />
      ))}
    </Wrapper>
  )
}

CollectionTemplate.propTypes = {
  data: propTypes.shape({
    main: propTypes.shape({
      frontmatter: propTypes.shape({
        cover: propTypes.string,
        bodyES: propTypes.string,
      }),
      html: propTypes.string,
    }).isRequired,
    items: propTypes.shape({
      edges: propTypes.object,
    }),
  }).isRequired,
  t: propTypes.func.isRequired,
  i18n: propTypes.shape({
    language: propTypes.string,
  }).isRequired,
}

export const query = graphql`
  query CollectionBySlug($slug: String!, $slugKey: String!) {
    main: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        name
        cover
        bodyES
      }
    }
    items: allMarkdownRemark(
      filter: { frontmatter: { collection: { eq: $slugKey } } }
    ) {
      edges {
        node {
          frontmatter {
            name
            collection
            thumb
            featured
            zoomimg
            bodyES
          }
          html
        }
      }
    }
  }
`

export default withTranslation(CollectionTemplate)
